<template>
  <div class="container underline-links">

    <h2 class="title">
      <slot name="title" />
    </h2>

    <slot name="subtitle" />

    <div class="form p-fluid">
      <slot name="form" />
    </div>

  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.container {
  width: toRem(490);
  margin: toRem(100) auto 0;
  padding: toRem(32);
  background: $bgBlocks;
  border-radius: 10px;
  box-shadow: 0 18px 50px -4px rgba(68, 72, 109, 0.1);
  backdrop-filter: blur(200px);
}

.title {
  margin-bottom: toRem(12);
  font-weight: 800;
  color: #0F1825;
}

.form {
  margin-top: toRem(20);
}

.form-buttons {
  margin-top: toRem(22);


  &.grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: toRem(8);
  }
}

.note {
  margin-top: toRem(10);
  font-size: toRem(12);

  &, a {
    color: $textThirdColor;
  }
}

.sub-title {
  margin: toRem(32) 0 toRem(18);
  font-weight: bold;
}
</style>
